import { QueryClient, isServer } from '@tanstack/react-query';

function makeQueryClient(isServer: boolean = false) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 1000 * 60 * 3, // 3분
        staleTime: 1000 * 60 * 1, // 1분
        refetchOnWindowFocus: false,
        retry: isServer ? 0 : 2, // 2번 재시도, 총 요청 3번
      },
      // dehydrate 설정 제거 - pending 쿼리는 dehydrate하지 않음
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    // Server: always make a new query client
    return makeQueryClient(true);
  } else {
    // Browser: make a new query client if we don't already have one
    // This is very important, so we don't re-make a new client if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query client
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}
